<div class="pp-panel">
  <app-list-header
    [heading]="documentType + ' history'"
    [compact]="true"
    [count]="loadingActionLogTable ? null : totalRecords"
    noun="change"></app-list-header>

  <div class="alog-scroll">
    <table class="pp-mini-table alog-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>User</th>
          <th>Action</th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadingActionLogTable">
          <tr *ngFor="let _ of skeletonRows">
            <td><p-skeleton width="7rem"></p-skeleton></td>
            <td><p-skeleton width="8rem"></p-skeleton></td>
            <td><p-skeleton width="5rem"></p-skeleton></td>
            <td><p-skeleton width="16rem"></p-skeleton></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!loadingActionLogTable">
          <tr *ngFor="let log of actionLogHistory">
            <td>
              <div class="pp-cell-stack">
                <span class="pp-cell-main">{{ log?.createdAt | date: 'EEE d MMM y' }}</span>
                <span class="pp-cell-sub">{{ log?.createdAt | date: 'h:mm a' }}</span>
              </div>
            </td>
            <td>
              <div class="pp-cell-person" *ngIf="log?.user; else alogDash">
                <span class="pp-avatar">{{ log.user | initials }}</span>
                <div class="pp-cell-stack">
                  <span class="pp-cell-main">{{ log.user }}</span>
                  <span *ngIf="log?.userRole" class="pp-cell-sub">{{ log.userRole | titlecase }}</span>
                </div>
              </div>
            </td>
            <td>
              <span *ngIf="log?.event; else alogDash" class="pp-tag">{{ log.event | titlecase }}</span>
            </td>
            <td class="alog-message">
              <ng-container *ngIf="messagePreview(log) as msg; else alogDash">
                <div class="alog-message__preview">{{ msg.preview }}</div>
                <button
                  *ngIf="msg.expandable"
                  type="button"
                  class="pp-btn pp-btn--ghost pp-btn--sm alog-message__view"
                  (click)="openMessage(log)">
                  View
                </button>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="!actionLogHistory.length">
            <td colspan="4">
              <app-list-empty
                [compact]="true"
                icon="pi-history"
                heading="No history yet"
                [text]="'Changes to this ' + (documentType | lowercase) + ' will be listed here.'"></app-list-empty>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <p-paginator
    *ngIf="totalRecords > rows"
    styleClass="alog-paginator"
    (onPageChange)="onPageChange($event)"
    [first]="first"
    [rows]="rows"
    [totalRecords]="totalRecords"></p-paginator>
</div>

<p-dialog
  [(visible)]="messageDialogOpen"
  [modal]="true"
  [style]="{ width: 'min(640px, 96vw)' }"
  header="Change details"
  appendTo="body"
  (onHide)="messageDialogOpen = false">
  <pre class="alog-message__full" *ngIf="!messageIsJson">{{ messageDialogText }}</pre>
  <pre class="alog-message__full alog-message__full--json" *ngIf="messageIsJson">{{ messageDialogText }}</pre>
</p-dialog>

<ng-template #alogDash><span class="pp-cell-muted">—</span></ng-template>
